import { Product } from './product.model';
import { Order } from '@usf/ngrx-order';
import {
  InsightsProducts,
  InsightsProductsFilter,
} from '@order/pages/order-insights/models/insights-products.model';

export interface OrderInsightData {
  orderInsightType: OrderInsightsType;
  product: Product;
  lastOrderedDate?: string | Date;
  casesAndEachesOrdered?: string;
}

export enum OrderInsightsType {
  LostLines = 'LOST LINES',
  NewProductsOrdered = 'NEW PRODUCTS ORDERED',
}

export interface OrderInsightsViewModel {
  orderSelected: Order | null;
  productMap: Map<number, Product>;
  lastOrderedDates: { [key: number]: string | Date };
  lostLinesProducts: InsightsProducts;
  newProductsOrderedProducts: InsightsProducts;
  productsInOrder: InsightsProducts;
  quickFilters: InsightsProductsFilter[];
  productsDisplayed: InsightsProducts[];
}
